import PropTypes from "prop-types";

const venuePropType = PropTypes.shape({
  code: PropTypes.string,
  name: PropTypes.string,
  rate: PropTypes.number,
});

export default venuePropType;
